import React, { Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";
import { generatePath, NavLink, useNavigate } from "react-router-dom";
import { useContextHospi } from "context/ContextHospi";
import {
  HOST_PROFILE_EDIT_FIRST_ROUTE,
  LOGIN_ROUTE,
  REGISTER_ROUTE,
  STUDENT_PROFILE_EDIT_FIRST_ROUTE
} from "utils/constants";
import { Item, StyledMenu } from "./styles";
import { signOut } from "../../../utils/utilAmplify";
import { useChat } from "../../../context/ContextChat/ContextChat";
import { useIsHost } from "../../../utils/helpers";
import { isChatPath, useGetProfileMenuRoutes } from "../../Menu/utils";

const ProfileMenu: React.FC<{
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
}> = ({ open, setOpen }) => {
  const { t, i18n } = useTranslation("header");
  const navigate = useNavigate();
  const {
    currentUserRole,
    setCurrentUserId,
    setCurrentUserRole,
    userProfile,
    currentUserName
  } = useContextHospi();

  const isHost = useIsHost();

  const {
    state: { chatCounters }
  } = useChat();

  const unreadCount = isHost
    ? (chatCounters?.requested ?? 0) + (chatCounters?.unread_accepted ?? 0)
    : chatCounters?.unread_accepted ?? 0;

  let menuRoutes = useGetProfileMenuRoutes();
  return (
    <StyledMenu open={open}>
      {!currentUserRole ? (
        <>
          <Item>
            <NavLink
              to={generatePath(LOGIN_ROUTE, {
                lng: i18n.language
              })}
              onClick={() => setOpen((prev) => !prev)}
            >
              {t("menu.signIn")}
            </NavLink>
          </Item>
          <Item>
            <NavLink
              to={generatePath(REGISTER_ROUTE, {
                lng: i18n.language
              })}
              onClick={() => setOpen((prev) => !prev)}
            >
              {t("menu.signUp")}
            </NavLink>
          </Item>
        </>
      ) : (
        <>
          <Item style={{ cursor: "default" }}>
            <p style={{ margin: 0 }}>{t(`subMenu.signedIn`)}</p>
            <p>{currentUserName}</p>
          </Item>
          <hr />
          {userProfile ? (
            menuRoutes.map((item) => (
              <Item key={item.path}>
                <NavLink
                  to={generatePath(item.path, {
                    lng: i18n.language,
                    id: isChatPath(item.path) ? "all" : ""
                  })}
                  onClick={() => {
                    setOpen((prev) => !prev);
                  }}
                >
                  <span style={{ position: "relative" }}>
                    {t(`subMenu.${item.keyLocalize}`)}{" "}
                    {isChatPath(item.path) && unreadCount
                      ? ` (${unreadCount})`
                      : ""}
                  </span>
                </NavLink>
              </Item>
            ))
          ) : (
            <Item>
              <NavLink
                to={`${
                  currentUserRole === "host"
                    ? generatePath(HOST_PROFILE_EDIT_FIRST_ROUTE, {
                        lng: i18n.language
                      })
                    : generatePath(STUDENT_PROFILE_EDIT_FIRST_ROUTE, {
                        lng: i18n.language
                      })
                }`}
                onClick={() => setOpen((prev) => !prev)}
              >
                {t(`subMenu.profile`)}
              </NavLink>
            </Item>
          )}
          <hr />
          <Item
            onClick={() => {
              signOut().finally(() => {
                setCurrentUserId(undefined);
                setCurrentUserRole(undefined);
              });
              setOpen((prev) => !prev);
              navigate(`/${i18n.language}/`);
            }}
          >
            {t(`subMenu.signOut`)}
          </Item>
        </>
      )}
    </StyledMenu>
  );
};
export default ProfileMenu;
